import { useEffect } from "react";
import { Navigate } from "react-router-dom";
import { ToastUtil } from "utilities/toastUtil";

export default function GoogleFail() {
  useEffect(() => {
    ToastUtil.showToastError(`Can't log in, please try again`);
  }, []);

  return <Navigate to="/sign-in" />;
}
